"use strict";
window._theme = window._theme || {};


// Helper functions
const closest = (element, selector) => {
  while (element && !element.matches(selector)) {
    element = element.parentElement;
  }
  return element;
};

const siblings = (element, selector = '*') => {
  const parent = element.parentElement;
  return Array.from(parent.children).filter(child => 
    child !== element && child.matches(selector)
  );
};

const nextUntil = (element, selector) => {
  const elements = [];
  let next = element.nextElementSibling;
  while (next && !next.matches(selector)) {
    elements.push(next);
    next = next.nextElementSibling;
  }
  return elements;
};

// Simple slide animations
const slideUp = (element, duration = 300) => {
  element.style.transition = `height ${duration}ms ease-out`;
  element.style.height = '0px';
  element.style.overflow = 'hidden';
  setTimeout(() => {
    element.style.display = 'none';
    element.style.height = '';
    element.style.transition = '';
  }, duration);
};

const slideDown = (element, duration = 300) => {
  element.style.display = 'block';
  element.style.height = '0px';
  element.style.overflow = 'hidden';
  
  const height = element.scrollHeight;
  element.style.transition = `height ${duration}ms ease-out`;
  element.style.height = height + 'px';
  
  setTimeout(() => {
    element.style.height = '';
    element.style.overflow = '';
    element.style.transition = '';
  }, duration);
};

const slideToggle = (element, duration = 300) => {
  if (element.style.display === 'none' || getComputedStyle(element).display === 'none') {
    slideDown(element, duration);
  } else {
    slideUp(element, duration);
  }
};

_theme.initHorizontalScroll = function(){
    // Handle panel group toggles
    document.querySelectorAll('.panel-group [data-toggle]').forEach(toggle => {
      toggle.addEventListener('click', function(evt) {
        evt.preventDefault();
        let expanded = this.getAttribute('aria-expanded');
        expanded = expanded ? JSON.parse(expanded) : false;
        
        const panel = closest(this, '.panel');
        const panelCollapse = panel.querySelector('.panel-collapse');
        const panelTitle = panel.querySelector('.panel-title');
        
        // Close other panels
        siblings(panel, '.panel').forEach(siblingPanel => {
          const siblingCollapse = siblingPanel.querySelector('.panel-collapse');
          const siblingTitle = siblingPanel.querySelector('.panel-title');
          slideUp(siblingCollapse);
          siblingTitle.classList.remove('rotateArrow');
        });
        
        // Toggle current panel
        slideToggle(panelCollapse);
        panelTitle.classList.toggle('rotateArrow');
        this.setAttribute('aria-expanded', !expanded);
      });
    });
    
    // Create tabber structure with proper ARIA attributes
    const accordionHeaders = document.querySelectorAll('#faqs_page .panel-group .accordion-header');
    const tabberHeader = document.querySelector('.faq-tabber-header');
    const tabberBody = document.querySelector('.faq-tabber-body');
    
    accordionHeaders.forEach((header, i) => {
      const text = header.textContent;
      const body = nextUntil(header, '.accordion-header');
      const tabId = `faq-tab-${i+1}`;
      const panelId = `faq-panel-${i+1}`;
    
      // Create tab with proper ARIA attributes
      const tabItem = document.createElement('div');
      tabItem.className = 'faq-tab-item font_24';
      tabItem.id = tabId;
      tabItem.setAttribute('role', 'tab');
      tabItem.setAttribute('tabindex', '-1');
      tabItem.setAttribute('aria-selected', 'false');
      tabItem.setAttribute('aria-controls', panelId);
      tabItem.setAttribute('aria-label', text);
      tabItem.innerHTML = `<div class="faq-tabber">${text}</div>`;
      tabberHeader.appendChild(tabItem);
    
      // Create tab panel with proper ARIA attributes
      const tabPanel = document.createElement('div');
      tabPanel.className = 'faq-tabber-content';
      tabPanel.id = panelId;
      tabPanel.setAttribute('role', 'tabpanel');
      tabPanel.setAttribute('aria-labelledby', tabId);
      tabPanel.setAttribute('aria-hidden', 'true');
      tabberBody.appendChild(tabPanel);
    
      // Move body content to panel
      body.forEach(item => {
        tabPanel.appendChild(item);
      });
    });
    
    // Set up tablist container
    tabberHeader.setAttribute('role', 'tablist');
    tabberHeader.setAttribute('aria-label', 'FAQ Categories');
    
    // Remove original FAQ page
    const faqsPage = document.querySelector('#faqs_page');
    if (faqsPage) {
      faqsPage.remove();
    }
    
    // Add mobile slider
    const slider = document.createElement('div');
    slider.className = 'faq-tab-slider visible-mobile right';
    slider.innerHTML = '<img src="//cdn.shopify.com/s/files/1/0910/0818/files/fade_right_arrow.svg" alt="">';
    tabberBody.parentNode.insertBefore(slider, tabberBody);
    
    // Handle tab click events
    document.addEventListener('click', function(evt) {
      if (evt.target.closest('.faq-tabber-header .faq-tab-item')) {
        evt.preventDefault();
        activateTab(evt.target.closest('.faq-tabber-header .faq-tab-item'));
      }
    });
    
    // Handle keyboard navigation for tabs
    document.addEventListener('keydown', function(evt) {
      if (evt.target.closest('.faq-tabber-header .faq-tab-item')) {
        const target = evt.target.closest('.faq-tabber-header .faq-tab-item');
        const tabs = Array.from(document.querySelectorAll('.faq-tabber-header .faq-tab-item'));
        const currentIndex = tabs.indexOf(target);
        let nextIndex = currentIndex;
    
        switch(evt.key) {
          case 'ArrowRight':
            evt.preventDefault();
            nextIndex = (currentIndex + 1) % tabs.length;
            tabs[nextIndex].focus();
            break;
          case 'ArrowLeft':
            evt.preventDefault();
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            tabs[nextIndex].focus();
            break;
          case 'Home':
            evt.preventDefault();
            tabs[0].focus();
            break;
          case 'End':
            evt.preventDefault();
            tabs[tabs.length - 1].focus();
            break;
          case 'Enter':
          case ' ':
            evt.preventDefault();
            activateTab(target);
            break;
          // Do NOT handle Tab key - allow it to move out of tablist
        }
      }
    });
    
    // Function to activate a tab
    function activateTab(tab) {
      const tabs = Array.from(document.querySelectorAll('.faq-tabber-header .faq-tab-item'));
      const tabIndex = tabs.indexOf(tab);
      const panels = Array.from(document.querySelectorAll('.faq-tabber-body .faq-tabber-content'));
    
      // Update tab states
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      
      tabs.forEach((t, index) => {
        if (index !== tabIndex) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
        }
      });
    
      // Update tab panel states
      panels.forEach((panel, index) => {
        if (index === tabIndex) {
          slideDown(panel);
          panel.setAttribute('aria-hidden', 'false');
        } else {
          slideUp(panel);
          panel.setAttribute('aria-hidden', 'true');
        }
      });
    
      // Update mobile header state
      tabberHeader.classList.toggle('active');
    
      // Announce tab change to screen readers
      const tabText = tab.querySelector('.faq-tabber').textContent;
      announceToScreenReader(`Switched to ${tabText} tab`);
    }
    
    // Function to announce changes to screen readers
    function announceToScreenReader(message) {
      const announcement = document.createElement('div');
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'sr-only';
      announcement.textContent = message;
      document.body.appendChild(announcement);
    
      setTimeout(() => {
        if (document.body.contains(announcement)) {
          document.body.removeChild(announcement);
        }
      }, 1000);
    }
    
    // Initialize first tab as active
    if (_theme.isMobile) {
      const firstTab = document.querySelector('.faq-tabber-header .faq-tab-item');
      const firstPanel = document.querySelector('.faq-tabber-body .faq-tabber-content');
      if (firstTab) {
        firstTab.classList.add('active');
        firstTab.setAttribute('aria-selected', 'true');
        firstTab.setAttribute('tabindex', '0');
      }
      if (firstPanel) {
        firstPanel.setAttribute('aria-hidden', 'false');
      }
    } else {
      const firstTab = document.querySelector('.faq-tabber-header .faq-tab-item');
      if (firstTab) {
        firstTab.click();
      }
    }
    
    // Handle mobile slider navigation
    document.querySelectorAll('.faq-tab-slider.left').forEach(slider => {
      slider.addEventListener('click', function() {
        const header = document.querySelector('.faq-tabber-header');
        header.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      });
    });
    
    // Handle Klarna FAQ items
    document.querySelectorAll('.klarna-faq-item button.heading').forEach(button => {
      button.addEventListener('click', function(event) {
        if (event.type === 'click' || event.keyCode === 13 || event.keyCode === 32) {
          event.preventDefault();
          
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          const faqItem = closest(this, '.klarna-faq-item');
          const content = faqItem.querySelector('.content');
          
          this.setAttribute('aria-expanded', !isExpanded);
          this.classList.toggle('active');
          slideToggle(content);
          
          // Close other FAQ items
          siblings(faqItem, '.klarna-faq-item').forEach(sibling => {
            const siblingButton = sibling.querySelector('button.heading');
            const siblingContent = sibling.querySelector('.content');
            siblingButton.setAttribute('aria-expanded', 'false');
            siblingButton.classList.remove('active');
            slideUp(siblingContent);
          });
        }
      });
    });
};

_theme.initFaq = function(){
  _theme.initHorizontalScroll();
};

document.addEventListener('DOMContentLoaded', _theme.initFaq);